var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosexIconw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.525 9.67033L19.1636 1.03172C19.3997 0.79563 19.3997 0.413161 19.1636 0.177069C18.9275 -0.059023 18.545 -0.059023 18.3089 0.177069L9.67033 8.81568L1.03172 0.177069C0.79563 -0.0590229 0.413161 -0.0590229 0.177069 0.177069C-0.059023 0.413161 -0.059023 0.79563 0.177069 1.03172L8.81568 9.67033L0.177069 18.3089C-0.0590229 18.545 -0.0590229 18.9275 0.177069 19.1636C0.295115 19.2816 0.449362 19.3407 0.604396 19.3407C0.759429 19.3407 0.913676 19.2816 1.03172 19.1636L9.67033 10.525L18.3089 19.1636C18.427 19.2816 18.5812 19.3407 18.7363 19.3407C18.8913 19.3407 19.0455 19.2816 19.1636 19.1636C19.3997 18.9275 19.3997 18.545 19.1636 18.3089L10.525 9.67033Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosexIconw);
export default __webpack_public_path__ + "static/media/ClosexIconw.9000e4f7afac698f618079ca38ea3c55.svg";
export { ForwardRef as ReactComponent };